import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const PLAYER = {
  name: "Alexander Ragontse",
  number: "33",
  position: "Center Mid / Striker",
  year: "Freshman",
  school: "McDonogh",
  from: "Boys' Latin",
  club: "Pipeline SC",
  image: "/assets/ragontse-33.jpeg",
  teamSlug: "soccer-boys-mcdonogh-school",
};

const FeaturedPlayer = () => {
  return (
    <section id="featured-player" className="pt-8">
      <div className="max-w-[1240px] mx-auto px-5 sm:px-8">
        <div className="flex sm:justify-end">
          {/* Subtle, compact horizontal card */}
          <Link
            to={`/team/${PLAYER.teamSlug}`}
            className="group flex items-center gap-4 w-full sm:w-auto sm:max-w-md rounded-2xl border border-[var(--line)] bg-[var(--paper)] p-3 pr-5 transition-all hover:border-[var(--olive)]"
          >
            <div className="relative shrink-0">
              <img
                src={PLAYER.image}
                alt={`${PLAYER.name}, #${PLAYER.number}`}
                className="w-20 h-20 rounded-xl object-cover object-top"
              />
              <span className="absolute -bottom-1.5 -right-1.5 grid place-items-center w-7 h-7 rounded-lg bg-[var(--olive)] text-white font-serif-display text-sm font-semibold">
                {PLAYER.number}
              </span>
            </div>

            <div className="min-w-0">
              <div className="text-[10px] font-bold tracking-eyebrow uppercase text-[var(--muted)]">
                Featured athlete
              </div>
              <div className="text-[15px] font-extrabold text-[var(--ink)] leading-tight mt-0.5">
                {PLAYER.name}
              </div>
              <div className="text-[12px] text-[var(--muted)] leading-snug">
                {PLAYER.year} {PLAYER.position} · {PLAYER.school} · from{" "}
                {PLAYER.from} · {PLAYER.club}
              </div>
            </div>

            <ArrowUpRight className="ml-auto w-4 h-4 text-[var(--muted)] shrink-0 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedPlayer;
